<template>
    <div class="user_wrap">
        <div class="top_header">
            <div class="flex flex-align pt-70 pl-20 pr-20">
                <div>
                    <img v-if="!data.avatar" style="width: 60px;height: 60px;" src="@/assets/images/nvidia.svg"/>
                    <img v-else :src="data.avatar" style="width: 60px;height: 60px;"/>
                </div>
                <div class="ml-10">
                    <div class="font-16 font-bold align-items">
                        {{ data.name ? data.name : data.mobile }}
                        <img v-if="data.job_level <= 0" @click="$router.push('/vip')" style="width: 30px;" src="@/assets/images/vip.svg">
                        <img v-else :src="data.level_icon" @click="$router.push('/vip')" style="height: 30px;">
                    </div>
                    <div class="font-14">{{ data.vip_name }}</div>
                </div>
                <div class="ml-10">

                </div>
            </div>
        </div>

        <div class="user_money">
            <div class="flex flex-align flex-between">
                <div>
                    <div class="font-16 font-bold">{{ $t("Total Assets") }}</div>
                    <div class="mt-10 font-16">{{$t('currency')}} {{ data.total_assets }}</div>
                </div>
                <div class="small-btn" @click="$router.push('/funds')">{{$t('Transaction Records')}}</div>
            </div>
            <div class="mt-20 flex">
                <div class="font-14">{{ $t("Available Balance") }}</div>
                <div class="ml-10 font-14 font-bold">{{ data.all_money }}</div>
            </div>
            <div class="mt-10 flex">
                <div class="font-14">{{ $t("user.uncollectedPrincipal") }}</div>
                <div class="ml-10 font-14 font-bold">{{ data.wait_money }}</div>
            </div>
            <div class="mt-10 flex">
                <div class="font-14">{{ $t("Locked Assets") }}</div>
                <div class="ml-10 font-14 font-bold" style="color: #76b900;" @click="$router.push('/locked')">
                    {{ data.unavailable_assets_balance }}
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="mt-10 flex">
                <div class="font-14">{{ $t("Frozen Assets") }}</div>
                <div class="ml-10 font-14 font-bold">{{ data.frozen_money }}</div>
            </div>
        </div>

        <div class="acea-row member-points">
            <div class="acea-row row-middle row-center item" @click="$router.push('/vip')">
                <div>
                    <div>{{$t('My Position')}}</div>
                    <div class="arrow">
                        {{$t('View new benefits')}}
                        <img class="rightarrow" src="@/assets/images/arrow.svg"/>
                    </div>
                </div>
                <div class="">
                    <img class="image" src="@/assets/images/user-member.png"/>
                </div>
            </div>
            <div class="acea-row row-middle row-center item" @click="$router.push('/future')">
                <div>
                    <div>{{$t('Future Bank')}}</div>
                    <div class="arrow">
                        {{$t('Start Investing')}}
                        <img class="rightarrow" src="@/assets/images/arrow.svg"/>
                    </div>
                </div>
                <div class="">
                    <img class="image" src="@/assets/images/user-points.png"/>
                </div>
            </div>
        </div>

        <div class="mySet">
            <div class="mySet-ul flex-p">
                <div class="mySet-li mySet-li-m flex-p" @click="$router.push('/cash')"
                     :class="byFlag == 'true' ? 'work_box_y' : ''">
                    <div class="item_img">
                        <img src="@/assets/images/withdrawal.svg"/>
                    </div>
                    <p class="item_title">{{ $t("Withdrawal") }}</p>
                </div>
                <div class="mySet-li flex-p" @click="$router.push('/review')"
                     :class="byFlag == 'true' ? 'work_box_y' : ''">
                    <div class="item_img">
                        <img src="@/assets/images/future.svg"/>
                    </div>
                    <p class="item_title">{{ $t("Reviews") }}</p>
                </div>
            </div>
        </div>

        <div class="list">
            <van-cell v-if="data.isr" is-link @click="$router.push('/redPacket')">
                <template #title>
                    <img src="@/assets/images/red_packet.svg" alt="" />
                    <span class="custom-title">{{$t('Redeem Red Packet')}}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="$router.push('/certification')">
                <template #title>
                    <img src="@/assets/images/kyc.svg" alt="" />
                    <span class="custom-title">{{ $t("Personal Verification") }}</span>
                </template>
            </van-cell>
<!--            <van-cell is-link @click="$router.push('/sign')">-->
<!--                <template #title>-->
<!--                    <img src="@/assets/images/sign.svg" alt="" />-->
<!--                    <span class="custom-title">{{ $t("Check-In") }}</span>-->
<!--                </template>-->
<!--            </van-cell>-->
<!--            <van-cell is-link @click="$router.push('/moneybag')">-->
<!--                <template #title>-->
<!--                    <img src="@/assets/images/wallet.svg" alt="" />-->
<!--                    <span class="custom-title">{{ $t("user.myWallet") }}</span>-->
<!--                </template>-->
<!--            </van-cell>-->
            <van-cell is-link @click="$router.push('/account')">
                <template #title>
                    <img src="@/assets/images/bank.svg" alt="" />
                    <span class="custom-title">{{ $t("safe.account") }}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="$router.push('/faq')">
                <template #title>
                    <img src="@/assets/images/faq1.svg" alt="" />
                    <span class="custom-title">{{ $t("FAQ") }}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="$router.push('/setpwd')">
                <template #title>
                    <img src="@/assets/images/loginpwd.svg" alt="" />
                    <span class="custom-title">{{ $t("safe.signInPassword") }}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="$router.push('/setpaypwd')">
                <template #title>
                    <img src="@/assets/images/paypwd.svg" alt="" />
                    <span class="custom-title">{{ $t("Withdrawal Password") }}</span>
                </template>
            </van-cell>
<!--            <van-cell is-link @click="$router.push('/review')">-->
<!--                <template #title>-->
<!--                    <img src="@/assets/images/reviews.svg" alt="" />-->
<!--                    <span class="custom-title">{{ $t("Reviews") }}</span>-->
<!--                </template>-->
<!--            </van-cell>-->
            <van-cell is-link @click="$router.push('/docs')">
                <template #title>
                    <van-icon name="description" color="#76b900" size="26"/>
                    <span class="custom-title" style="margin-left: 10px">{{ $t("Beginner Tutorial") }}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="clickHandle">
                <template #title>
                    <img src="@/assets/images/download.svg" alt="" />
                    <span class="custom-title">{{ $t("Download App") }}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="logout">
                <template #title>
                    <img src="@/assets/images/switch.svg" alt="" />
                    <span class="custom-title">{{ $t("Switch Account") }}</span>
                </template>
            </van-cell>
            <van-cell is-link @click="logout">
                <template #title>
                    <img src="@/assets/images/logout.svg" alt="" />
                    <span class="custom-title">{{ $t("Log out") }}</span>
                </template>
            </van-cell>
        </div>

        <!-- <div class="kong"></div> -->
        <!-- <div class="user_yw">
          <div @click="$router.push('/order')">
            <img src="../images/user/order.png" alt="" />
            <p>{{ $t("user.myInvestment") }}</p>
          </div>
          <div @click="$router.push('/moneybag')">
            <img src="../images/user/details.png" alt="" />
            <p>{{ $t("user.transactionDetails") }}</p>
          </div>
          <div @click="$router.push('/kefu')">
            <img src="../images/user/kf.png" alt="" />
            <p>{{ $t("user.onlineService") }}</p>
          </div>
        </div> -->
        <!-- <div class="money">
          <div>
            <p>{{ $t("user.availableBalance") }}</p>
            <p>{{ $t("utils.moneyMark") }}{{ data.money }}</p>
          </div>
          <div>
            <span @click="$router.push('/invest')">{{ $t("user.recharge") }}</span>
            <span @click="$router.push('/cash')">{{ $t("user.withdraw") }}</span>
          </div>
        </div> -->
        <!-- <div class="list">
          <van-cell is-link @click="$router.push('/moneybag')">
            <template #title>
              <img src="../images/user/moneybag.png" alt="" />
              <span class="custom-title">{{ $t("user.myWallet") }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="$router.push('/rechargeRecord')">
            <template #title>
              <img src="../images/user/cz.png" alt="" />
              <span class="custom-title">{{ $t("user.rechargeRecord") }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="$router.push('/withdrawRecord')">
            <template #title>
              <img src="../images/user/tx.png" alt="" />
              <span class="custom-title">{{ $t("user.withdrawalRecord") }}</span>
            </template>
          </van-cell>
        </div> -->
        <!--    <div class="list">-->
        <!--      <van-cell is-link @click="$router.push('/myTeam')">-->
        <!--        <template #title>-->
        <!--          <img src="../images/about/icon8.png" alt="" />-->
        <!--          <span class="custom-title">{{ $t("index.invite") }}</span>-->
        <!--        </template>-->
        <!--      </van-cell>-->
        <!--      <van-cell is-link @click="$router.push('/safe')">-->
        <!--        <template #title>-->
        <!--          <img src="../images/user/setting.png" alt="" />-->
        <!--          <span class="custom-title">{{ $t("user.setting") }}</span>-->
        <!--        </template>-->
        <!--      </van-cell>-->
        <!--    </div>-->
        <div style="height: 90px;"></div>
    </div>
</template>

<script>
    import Vue from "vue";
    import qs from "qs";
    import Fetch from "../../utils/fetch";
    import Api from "../../interface/index";
    import {Icon, Cell, CellGroup} from "vant";

    Vue.use(Cell).use(CellGroup).use(Icon);

    export default {
        name: "user",
        components: {},
        data() {
            return {
                data: {},
                f: "",

                eye: 1,
                byFlag: localStorage.getItem('byFlag'),
                userName: '',
            };
        },
        created() {
            (this.f =
                localStorage.getItem("f") == "#fff"
                    ? "#44ADFE"
                    // : localStorage.getItem("f") || "##E9C78C"),
                    : localStorage.getItem("f") || "#47b897"),
                this.$parent.footer("user");
        },
        mounted() {
            this.start();
        },
        methods: {
            toKefu() {
                // const dom = document.getElementById('apbd-cht-btn');
                // dom.click();
                Fetch('/index/webconfig', {type: 'web'}).then(res => {
                    this.data = res.data;
                    let link = res.data.kefu_link;
                    link = link.replace('{0}', this.userName);
                    window.location.href = link;
                })
            },
            start() {
                Fetch("/user/info").then((r) => {
                    this.data = r.data;
                    this.userName = this.data.name ? this.data.name : this.data.mobile;
                });
            },
            logout() {
                localStorage.removeItem('token');
                localStorage.removeItem('user_id');
                localStorage.removeItem('user_name');
                this.$router.replace("/login");
            },
            clickHandle() {
                window.open(this.$store.state.config.app_link, '_blank');
                // location.href = this.$store.state.config.app_link;
                // let p = navigator.platform;
                // let u = navigator.userAgent;
                // let is_android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
                // let is_ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                // if (p == "Win32" || p == "Win64" || p == "MacPPC" || p == "MacIntel" || p == "X11" || p == "Linux i686") {//PC调试环境
                //     // console.log('PC环境--供PC端调试');
                //     location.href = 'https://play.google.com/store/apps/details?id=com.rogenotes.pro';
                // } else {
                //     if (is_android) {//Android终端
                //         // console.log('Mobile环境--Android移动端');
                //         location.href = 'https://play.google.com/store/apps/details?id=com.rogenotes.pro';
                //     } else if (is_ios) {//IOS终端
                //         // console.log('Mobile环境--IOS移动端');
                //         location.href = 'https://apps.apple.com/us/app/itunes-connect/id376771144';
                //     }
                // }
            }
        },
    };
</script>

<style lang="less" scoped>
    .new-user-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 30px;
        padding-bottom: 15px;
    }

    .line-box {
        .new-line {
            width: 90%;
            height: 2px;
            background: #fff;
        }
    }

    .mySet {
        margin: 20px 10px;

        .mySet-ul {
            margin-bottom: 10px;

            .mySet-li {
                background: #ffffff;
                box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
                border-radius: 5px;
                width: 100%;
                padding: 10px 10px;

                .item_img {
                    margin-right: 10px;

                    img {
                        width: 26px;
                        height: 26px;
                    }
                }

                .item_title {
                    font-size: 13px;
                    font-family: PingFang;
                    font-weight: bold;
                    color: #000000;
                }
            }

            .mySet-li-m {
                margin-right: 10px;
            }
        }
    }

    .user_wrap {
        //   background-color: #fafafa;
        max-width: 100%;
        overflow: hidden;
    }

    .top_header {
        position: relative;
        width: 100%;
        height: 190px;
        background-size: 100% 100%;
        background: url("~@/assets/images/bg1.jpg");
        background-size: cover;

        .set_go {
            width: 38px;
            height: 38px;
            position: absolute;
            top: 11px;
        }

        .set_go {
            right: 14px;
            background: url(../images/user/sign.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .user_detail {
            // width: 100%;
            // padding: 28px 15px 0 15px;
            // top: 34px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .user_header {
                width: 50px;
                height: 50px;
                overflow: hidden;
                border-radius: 50%;
                border: 3px solid rgba(255, 255, 255, 0.3);

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .user_name {
                margin-left: 3px;
                margin-top: 3px;
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                color: #000;

                .user_all {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .user_nickname {
                        line-height: 21px;
                        font-size: 16px;
                        font-weight: bold;

                        font-weight: 400;
                        color: #000000;
                    }
                }
            }
        }

        .user_vip {
            color: #ffffff;
            font-weight: bold;
            font-size: 16px;
            margin: 10px 20px 20px 20px;
        }

        .user_balance {
            text-align: center;

            div {
                //   margin: 10px 0;
            }

            div:nth-child(1) {
                font-size: 24px;
                font-weight: 400;
                color: #000;
            }

            div:nth-child(2) {
                font-size: 14px;
                font-weight: 400;
                color: #000;
                margin-top: 5px;
            }
        }
    }

    .kong {
        width: 100%;
        height: 35px;
        background: #ffffff;
    }

    .user_yw {
        display: flex;
        justify-content: space-between;
        text-align: center;
        width: 96%;
        position: relative;
        //   top: -83px;
        background: #ffffff;
        left: 2%;
        border-radius: 5px 5px 0 0;
        padding: 15px 0;

        div {
            width: 33.33%;
        }

        p {
            margin-top: 8px;
        }

        img {
            width: 30px;
            height: 30px;
        }
    }

    .money {
        display: flex;
        justify-content: space-between;
        width: 96%;
        background: #ffffff;
        border-radius: 5px;
        margin-top: -73px;
        margin-left: 2%;
        padding: 15px;

        div:nth-child(1) {
            width: 40%;
            text-align: left;

            p:nth-child(1) {
                color: #999;
                margin-bottom: 10px;
            }

            p:nth-child(2) {
                font-size: 14px;
                font-weight: bold;
            }
        }

        div:nth-child(2) {
            width: 60%;
            text-align: right;
            margin-top: 12px;

            span {
                padding: 5px 10px;
                border-radius: 5px;
                margin: 0 5px;
            }

            span:nth-child(1) {
                color: #ffffff;
                background: #3775f4;
            }

            span:nth-child(2) {
                color: #3775f4;
                background: #e9f0fb;
            }
        }
    }

    .list {
        margin: 10px;
        border-radius: 5px;

        img {
            vertical-align: middle;
            height: 26px;
            width: 26px;
            margin-right: 10px;
        }
    }
</style>
